import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaFurniture} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {FurnitureModel} from '../../../../../../model'
import {createFurniture, updateFurniture} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../../components/UI/Select'
import {InputText} from '../../../../../../../../components/UI/Input'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getFurnitureList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: any
}

const ModalAddFurniture: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getFurnitureList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useLavanderia()
  const [typeFurniture, setTypeFurniture] = useState<FurnitureModel[] | any>([])
  const methods = useForm<FurnitureModel>({
    resolver: yupResolver(schemaFurniture),
  })
  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods

  const getTypeFurnitureList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'MobiliarioLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    if (idPermission) {
      setValue('mobiliario.tipoMobiliario', detailpermission?.tipoMobiliario.trim())
      setValue('mobiliario.descripcion', detailpermission?.descripcion)
      setValue('mobiliario.codigo', detailpermission?.codigo)
      setValue('mobiliario.observaciones', detailpermission?.observaciones)
      // getPermissionByOptionList(detailpermission?.vistaPermisoId)
    }
  }, [idPermission])

  useEffect(() => {
    getTypeFurnitureList()
  }, [])

  const handleClose = () => {
    setShow(false)
    setValue('mobiliario.codigo', '')
    setValue('mobiliario.descripcion', '')
    setValue('mobiliario.estado', '')
    setValue('mobiliario.observaciones', '')
    setValue('mobiliario.tipoMobiliario', '')

    setIdPermissionList()
  }

  const onSubmit = async (data: FurnitureModel) => {
    try {
      if (idPermission) {
        let obj = {
          id: idPermission,
          puntoId: currentTabItem.idToEdit,
          ...data.mobiliario,
        }

        const {data: res} = await updateFurniture(obj)
        if (!res.error) {
          handleClose()
          getFurnitureList()
          //mostrar snackbar
        }
      } else {
        let obj = {
          puntoId: currentTabItem.idToEdit,
          ...data.mobiliario,
        }

        const {data: res} = await createFurniture(obj)
        if (!res.error) {
          handleClose()
          getFurnitureList()
          //mostrar snackbar
        }
      }
    } catch (error) {}
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Mobiliario</h5>
          ) : (
            <h5 className='modal-title'>Agregar Mobiliario</h5>
          )}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-6'>
                  <label className='required'>Tipo de Mobiliario</label>
                  <Select
                    control={control}
                    name='mobiliario.tipoMobiliario'
                    data={typeFurniture}
                    errors={errors}
                  />
                  {errors.mobiliario && 'tipoMobiliario' in errors.mobiliario && (
                    <p className='error-message'>
                      {errors.mobiliario.tipoMobiliario?.message?.toString()}
                    </p>
                  )}
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Descripción de Mobiliario:</label>
                  <InputText
                    name='mobiliario.descripcion'
                    textPlaceholder='Escribe el código'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                  />
                  {errors.mobiliario && 'descripcion' in errors.mobiliario && (
                    <p className='error-message'>
                      {errors.mobiliario.descripcion?.message?.toString()}
                    </p>
                  )}
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Código de Mobiliario:</label>
                  <InputText
                    name='mobiliario.codigo'
                    textPlaceholder='Escribe el código'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                  />
                  {errors.mobiliario && 'codigo' in errors.mobiliario && (
                    <p className='error-message'>{errors.mobiliario.codigo?.message?.toString()}</p>
                  )}
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Observaciones:</label>
                  <InputText
                    name='mobiliario.observaciones'
                    textPlaceholder='Escribe el código'
                    register={register}
                    errors={errors}
                    Uppercase={true}
                  />
                  {errors.mobiliario && 'observaciones' in errors.mobiliario && (
                    <p className='error-message'>
                      {errors.mobiliario.observaciones?.message?.toString()}
                    </p>
                  )}
                </div>
              </div>

              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddFurniture}
